import { Component } from '@theme/component';

/**
 * Client-side filter for the brands / vendors directory.
 *
 * @typedef {object} VendorsListRefs
 * @property {HTMLInputElement} [searchInput]
 * @property {HTMLElement} [groups]
 * @property {HTMLElement} [emptyState]
 *
 * @extends {Component<VendorsListRefs>}
 */
class VendorsListComponent extends Component {
  filterVendors() {
    const query = (this.refs.searchInput?.value || '').trim().toLowerCase();
    const items = this.querySelectorAll('.vendors-list__item');
    const groups = this.querySelectorAll('.vendors-list__group');
    let visibleCount = 0;

    items.forEach((item) => {
      if (!(item instanceof HTMLElement)) return;

      const name = item.dataset.vendorName || '';
      const isMatch = query === '' || name.includes(query);
      item.toggleAttribute('hidden', !isMatch);

      if (isMatch) visibleCount += 1;
    });

    groups.forEach((group) => {
      if (!(group instanceof HTMLElement)) return;

      const hasVisibleItem = Boolean(group.querySelector('.vendors-list__item:not([hidden])'));
      group.toggleAttribute('hidden', !hasVisibleItem);
    });

    if (this.refs.emptyState) {
      this.refs.emptyState.toggleAttribute('hidden', visibleCount > 0);
    }
  }
}

if (!customElements.get('vendors-list-component')) {
  customElements.define('vendors-list-component', VendorsListComponent);
}
